<fn-modal-header class="modal-header">
    <h5 class="modal-title" mat-dialog-title>EOMailTeam</h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</fn-modal-header>
<mat-dialog-content>
    <div class="row">
        <div class="col-6">
                <label for="Name">Name</label>
                <fn-base-input placeholder="Enter name" [(ngModel)]="objectHash.id"
                    [ngModelOptions]="{standalone: true}"></fn-base-input>

        </div>       
        <div class="col-6">
        <label for="Name">defaultEscEmailID</label>
                <fn-base-input placeholder="Enter defaultEscEmailID" [(ngModel)]="objectHash.name"
                    [ngModelOptions]="{standalone: true}"></fn-base-input>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="row">
        <div class="col-6 text-left">
            <button class="btn btn-danger float-left btn-round" (click)="close()">Cancel</button>
        </div>
        <div class="col-6  text-right">
            <button class="btn btn-primary float-right btn-round" (click)="add()">{{ isEdit ? 'Update' : 'Add' }}</button>
        </div>
    </div>
</mat-dialog-actions>
